// Klick-Tracking für Telefon- (tel:) & WhatsApp-Links (wa.me / api.whatsapp.com).
// Ein globaler Click-Listener fängt ALLE entsprechenden Links ab – Header, Footer,
// Kursseiten, Sticky-Buttons, Dialoge – ohne jede Komponente einzeln anzufassen.
//
// Datenschutz: Events feuern NUR nach Marketing-Einwilligung im Cookie-Banner
// (dh-consent = "accepted") – wie die bestehenden Lead-Events. Die bestehenden
// Formular-Lead-Conversions (trackLeadConversion / metaLead) bleiben unberührt;
// Meta bekommt hier bewusst trackCustom-Events (kein "Lead"), damit nichts
// doppelt als Lead gezählt wird.
//
// Google-Ads-Conversion-Labels (Conversion-Aktion im Ads-Konto anlegen, Label
// dann in /app/frontend/.env eintragen – Platzhalter beginnen mit "HIER_" und
// werden vom Code ignoriert, bis ein echtes Label eingetragen ist):
//   REACT_APP_GOOGLE_ADS_PHONE_LABEL     → Aktion „Anruf-Klick (phone_click)"
//   REACT_APP_GOOGLE_ADS_WHATSAPP_LABEL  → Aktion „WhatsApp-Klick (whatsapp_click)"

const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "";
const PHONE_LABEL = process.env.REACT_APP_GOOGLE_ADS_PHONE_LABEL || "";
const WHATSAPP_LABEL = process.env.REACT_APP_GOOGLE_ADS_WHATSAPP_LABEL || "";

const WA_PATTERN = /(^|\/\/)(wa\.me|api\.whatsapp\.com)/i;

function isRealLabel(label) {
  return Boolean(label) && !label.startsWith("HIER_");
}

function hasMarketingConsent() {
  try {
    return localStorage.getItem("dh-consent") === "accepted";
  } catch {
    return false;
  }
}

function fireContactEvent(eventName, conversionLabel, value, meta) {
  if (!hasMarketingConsent()) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...meta, value, currency: "EUR" });
  if (window.gtag) {
    const params = { ...meta, value, currency: "EUR" };
    if (ADS_ID) params.send_to = ADS_ID;
    window.gtag("event", eventName, params);
    if (ADS_ID && isRealLabel(conversionLabel)) {
      window.gtag("event", "conversion", {
        send_to: `${ADS_ID}/${conversionLabel}`,
        value,
        currency: "EUR",
      });
    }
  }
  if (window.fbq) {
    window.fbq("trackCustom", eventName, meta);
  }
}

let installed = false;

/** Einmalig beim App-Start registrieren (idempotent). */
export function initClickTracking() {
  if (installed || typeof document === "undefined") return;
  installed = true;
  document.addEventListener(
    "click",
    (e) => {
      try {
        const a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
        if (!a) return;
        const href = a.getAttribute("href") || "";
        const source = a.dataset.trackSource || window.location.pathname || "unknown";
        if (href.startsWith("tel:")) {
          fireContactEvent("phone_click", PHONE_LABEL, 15, {
            contact_method: "phone",
            link_url: href,
            source,
          });
        } else if (WA_PATTERN.test(href)) {
          fireContactEvent("whatsapp_click", WHATSAPP_LABEL, 15, {
            contact_method: "whatsapp",
            link_url: href.split("?")[0],
            source,
          });
        }
      } catch {
        // Tracking darf den Klick niemals blockieren
      }
    },
    true
  );
}
